// import handlebars from 'handlebars';
import { getApiDataByPath  } from './apiDataService';
import { WIDGET_CONTENT_VARIABLES } from './contentVariables';

/**
 * Process single string and returns new string replacing handlebars placeholders with Data Source API data
 * @param data Api Data Object
 * @param string lookup key
 * @param status indicates if data is still loading or final
 * @returns string with Api Data values
 */
export function processDataString(data, string, status: Symbol): string|null|undefined {
    return string.replace(/{{(.+?)}}/g, (match, group) => {
        const dataParts = group.split(',').map(p => p.trim());
        if (!dataParts || !dataParts.length) {
            // if "{{}}" is found
            return '[N/A]';
        }

        // get dataKey
        const dataKey = dataParts[0];
        // remove dataKey
        dataParts.splice(0, 1);

        // Check if datakey does not need to be replaced in this step
        if (WIDGET_CONTENT_VARIABLES.includes(dataKey)) {
            return `{{${dataKey}}}`;
        }

        // check for formatType
        let formatType;
        if (dataParts.length) {
            const dataTypeIndex = dataParts.findIndex(d => ['$', '%', '#', 'date', 'timeAgo'].includes(d));
            if (dataTypeIndex > -1) { // found a data type
                formatType = dataParts[dataTypeIndex];
                dataParts.splice(dataTypeIndex, 1);
            }
        }

        // check for precision
        let precision;
        if (dataParts.length) {
            precision = Number(dataParts[0]);
        }

        return getApiDataByPath(data, dataKey, status, precision ? Number(precision) : null, formatType);
    });
}

/**
 * Process all widget props of type string and replace placeholders with Data Source API data
 * @param data Api Data Object
 * @param props list of widget props
 * @param status indicates if data is still loading or final
 * @returns new list of widget props with expanded api data values
 */
export function processDataProps(data, props, status: Symbol) {
    if (!props) return props;
    const newProps = {};
    for (const [key, value] of Object.entries(props)) {
        if (typeof value === 'string') {
            newProps[key] = processDataString(data, value, status);
        } else {
            newProps[key] = value;
        }
    }
    return newProps;
}
